import { COUPON_SERVICE_APIS } from "@/api_framework/api_config";
import { IUserLevelCoupon, IUserLevelCouponCreateBody } from "@/api_framework/api_modals/coupon";
import { useConfiguration } from "@/app/hooks/useConfiguration";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import axios, { AxiosError, AxiosResponse } from "axios";
import AxiosCurlirize from "axios-curlirize";
import { useCallback } from "react";
import toast from "react-hot-toast";

AxiosCurlirize(axios, () => {});

export const useCreateUserLevelCouponAPI = () => {
  const configuration = useConfiguration();
  const { sendCurl } = useCurlLogger();

  const execute = useCallback(
    async (body: IUserLevelCouponCreateBody): Promise<{ status: boolean; data?: IUserLevelCoupon }> => {
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
        return await axios
          .post(COUPON_SERVICE_APIS?.USER_LEVEL_COUPON?.baseURL, body, {
            headers: { Authorization: `${accessToken}`, "Content-Type": "application/json" },
          })
          .then((res: AxiosResponse<{ status: boolean; message: string; data: IUserLevelCoupon }>) => {
            if (res.data.status) return { status: true, data: res.data.data };
            toast.error(res.data.message || "Could not create coupon");
            return { status: false };
          })
          .catch((e: AxiosError<any>) => {
            sendCurl(e.config["curlCommand"]);
            toast.error(e.response?.data?.message || "Could not create coupon");
            return { status: false };
          });
      } catch (e: any) {
        toast.error("Server Error: " + e.message);
        return { status: false };
      }
    },
    [],
  );

  return { execute };
};
